import React from 'react';
import styled from 'styled-components';
import Spinner from 'components/Spinner';
import PropTypes from 'prop-types';
import { FormControl, Alert } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import RouteCounter from './RouteCounter';

export const Input = styled(FormControl)`
  &.form-control {
    max-width: 12em;
  }
`;

export const ControlWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
`;
function RoutesHeader({
  filter,
  routes,
  totalCount,
  filterCount,
  changeFilter,
}) {
  if (!routes) {
    return <Spinner />;
  }
  if (totalCount.length === 0) {
    return (
      <Alert bsStyle="warning">
        <FormattedMessage {...messages.noRoutes} />
      </Alert>
    );
  }
  return (
    <ControlWrapper>
      <span>
        <FormattedMessage {...messages.numberRoutes} />
        <RouteCounter
          filter={filter}
          totalCount={totalCount}
          filterCount={filterCount}
        />
      </span>
      <Input
        type="search"
        value={filter}
        placeholder="Filter"
        onChange={changeFilter}
      />
    </ControlWrapper>
  );
}
RoutesHeader.propTypes = {
  filter: PropTypes.string.isRequired,
  routes: PropTypes.array,
  totalCount: PropTypes.number,
  filterCount: PropTypes.number,
  changeFilter: PropTypes.func.isRequired,
};

RoutesHeader.displayName = 'RoutesHeader';

export default RoutesHeader;
